import { render } from "./OverviewFollowUps.vue?vue&type=template&id=585ebe0a&scoped=true"
import script from "./OverviewFollowUps.vue?vue&type=script&lang=js"
export * from "./OverviewFollowUps.vue?vue&type=script&lang=js"

import "./OverviewFollowUps.vue?vue&type=style&index=0&id=585ebe0a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585ebe0a"],['__file',"src/scripts/view/review/components/receiver/OverviewFollowUps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "585ebe0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('585ebe0a', __exports__)) {
    api.reload('585ebe0a', __exports__)
  }
  
  module.hot.accept("./OverviewFollowUps.vue?vue&type=template&id=585ebe0a&scoped=true", () => {
    api.rerender('585ebe0a', render)
  })

}


export default __exports__